import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import "./base.css";
// import "./index.css";
import Main from "./pages/Main";
import HanapegiPlay from "./pages/HanapegiPlay";
import Ranking from "./pages/Ranking";
import EthersProvider from "./ethers/EthersProvider";
// import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <EthersProvider>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Main />}></Route>
        <Route path="/hanapegiplay" element={<HanapegiPlay />}></Route>
        <Route path="/ranking" element={<Ranking />}></Route>
      </Routes>
    </BrowserRouter>
  </EthersProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
